import { Routes } from '@angular/router';
import { authGuard, adminGuard, loginPageGuard, setPasswordPageGuard, permissionGuard, seoGuard, nonSeoGuard, cartManagerGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: 'seo',
        canActivate: [authGuard, seoGuard],
        loadComponent: () =>
            import('./layout/seo-layout/seo-layout').then((m) => m.SeoLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./features/dashboard/pages/home/home').then((m) => m.HomeComponent),
            },
            {
                path: 'create-content',
                loadComponent: () =>
                    import('./features/user-profile/pages/create-content/create-content').then((m) => m.CreateContentComponent),
            },
            {
                path: 'seo-document-types',
                loadComponent: () =>
                    import('./features/user-profile/pages/seo-document-types/seo-document-types').then((m) => m.SeoDocumentTypesComponent),
            },
            {
                path: 'seo-document-types/:id',
                loadComponent: () =>
                    import('./features/user-profile/pages/seo-document-detail/seo-document-detail').then((m) => m.SeoDocumentDetailComponent),
            },
            {
                path: 'website-dashboard/:id',
                loadComponent: () =>
                    import('./features/user-profile/pages/website-dashboard/website-dashboard').then((m) => m.WebsiteDashboardComponent),
            },
            {
                path: 'websites/:id/settings',
                loadComponent: () =>
                    import('./features/user-profile/pages/website-settings/website-settings').then((m) => m.WebsiteSettingsComponent),
            },
            {
                path: 'websites/:id/external-countries',
                loadComponent: () =>
                    import('./features/user-profile/pages/external-countries/external-countries').then((m) => m.ExternalCountriesComponent),
            },
        ],
    },
    {
        path: '',
        canActivate: [authGuard, nonSeoGuard],
        loadComponent: () =>
            import('./layout/main-layout/layout').then((m) => m.LayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./features/dashboard/pages/home/home').then((m) => m.HomeComponent),
            },
            {
                path: 'users',
                canActivate: [permissionGuard('view-users')],
                loadComponent: () =>
                    import('./features/user-profile/pages/users/users').then((m) => m.UsersComponent),
            },
            {
                path: 'roles',
                canActivate: [permissionGuard('view-roles')],
                loadComponent: () =>
                    import('./features/user-profile/pages/roles/roles').then((m) => m.RolesComponent),
            },
            {
                path: 'websites',
                canActivate: [permissionGuard('view-websites')],
                loadComponent: () =>
                    import('./features/user-profile/pages/websites/websites').then((m) => m.WebsitesComponent),
            },
            {
                path: 'websites/:id/settings',
                canActivate: [permissionGuard('view-websites')],
                loadComponent: () =>
                    import('./features/user-profile/pages/website-settings/website-settings').then((m) => m.WebsiteSettingsComponent),
            },
            {
                path: 'websites/:id/dashboard',
                canActivate: [permissionGuard('view-websites')],
                loadComponent: () =>
                    import('./features/user-profile/pages/website-dashboard/website-dashboard').then((m) => m.WebsiteDashboardComponent),
            },
            {
                path: 'websites/:id/external-countries',
                canActivate: [permissionGuard('view-websites')],
                loadComponent: () =>
                    import('./features/user-profile/pages/external-countries/external-countries').then((m) => m.ExternalCountriesComponent),
            },
            {
                path: 'seo-document-types',
                canActivate: [permissionGuard('view-seo-document-types')],
                loadComponent: () =>
                    import('./features/user-profile/pages/seo-document-types/seo-document-types').then((m) => m.SeoDocumentTypesComponent),
            },
            {
                path: 'seo-document-types/:id',
                canActivate: [permissionGuard('view-seo-document-types')],
                loadComponent: () =>
                    import('./features/user-profile/pages/seo-document-detail/seo-document-detail').then((m) => m.SeoDocumentDetailComponent),
            },
            {
                path: 'create-content',
                loadComponent: () =>
                    import('./features/user-profile/pages/create-content/create-content').then((m) => m.CreateContentComponent),
            },
            {
                path: 'doc-cases',
                loadComponent: () =>
                    import('./features/user-profile/pages/doc-cases/doc-cases').then((m) => m.DocCasesComponent),
            },
            {
                path: 'states',
                loadComponent: () =>
                    import('./features/user-profile/pages/states/states').then((m) => m.StatesComponent),
            },
            {
                path: 'admin-carts',
                canActivate: [adminGuard],
                loadComponent: () =>
                    import('./features/user-profile/pages/admin-carts/admin-carts').then((m) => m.AdminCartsComponent),
                data: {
                    status: 'Order Placed',
                    title: 'Admin Carts',
                    subtitle: 'View and manage all customer cart orders across websites',
                },
            },
            {
                path: 'pending-carts',
                canActivate: [cartManagerGuard],
                loadComponent: () =>
                    import('./features/user-profile/pages/admin-carts/admin-carts').then((m) => m.AdminCartsComponent),
                data: {
                    status: 'pending',
                    title: 'Pending Carts',
                    subtitle: 'View and manage all pending customer carts across websites',
                },
            },
            {
                path: 'cart-lookup',
                canActivate: [cartManagerGuard],
                loadComponent: () =>
                    import('./features/user-profile/pages/cart-lookup/cart-lookup').then((m) => m.CartLookupComponent),
            },
        ],
    },

    {
        path: '',
        loadComponent: () => import('./layout/auth-layout/auth-layout').then((m) => m.AuthLayoutComponent),
        children: [
            {
                path: 'login',
                canActivate: [loginPageGuard],
                loadComponent: () => import('./features/user-profile/pages/login/login').then((m) => m.LoginComponent),
            },
            {
                path: 'set-password',
                canActivate: [setPasswordPageGuard],
                loadComponent: () => import('./features/user-profile/pages/set-password/set-password').then((m) => m.SetPasswordComponent),
            },
            {
                path: 'reset-password',
                canActivate: [loginPageGuard],
                loadComponent: () => import('./features/user-profile/pages/reset-password/reset-password').then((m) => m.ResetPasswordComponent),
            },
        ]
    },

    {
        path: '**',
        redirectTo: '',
    },
];
